module.exports = __webpack_public_path__ + "img/1_024.2f3a73fc.jpg";